import React, { useEffect, useContext, useState } from "react";
import { Link, scrollSpy } from "react-scroll";
import { withRouter } from "react-router-dom";
import datas from "../../../datas/rubriques.json";


const SubNav = ({ location }) => {
    const [_datas, _setDatas] = useState(null);

    useEffect(() => {
        const hash = location.hash;

        // Get datas depending on slug location
        const datasArray = datas.filter(
            (item) => `/${item.slug}/` == location.pathname
        )[0]?.subRubriques;
        _setDatas(datasArray);

        // hash
        if(hash ===''){

            window.scrollTo(0, 0)
        }
        // else scroll to id
        else{
            window.scrollTo(0, 1)
            setTimeout(
                () => {
                    const _id = hash?.replace('#', '');
                    const id = _id.split('/')[0];
                    const element = document.getElementById(id);
                    if (element) {
                        element.scrollIntoView();
                    }
                },
                100
            );
        }

    }, [location]);

  // ${location?.hash && location.hash === `#${slug}` ? 'active' : '' }
    return _datas?.length > 0
        ? (
        <div id="subnav" className={location.hash.substring(1)}>
            {
                _datas?.length > 0 && _datas?.map((item, index) => {
                    const { title, slug } = item;
                    return (
                        <Link
                            key={`${slug}${index}`}
                            activeClass="active"
                            to={`${slug}`}
                            spy
                            smooth
                            hashSpy
                            offset={0}
                            duration={700}
                            className={`nav-link subnav__${ slug } `}
                        >
                            {title}
                        </Link>
                    );
                })
            }
        </div>
        )
        :
        ''
};
export default withRouter(SubNav);
